import { RootState } from '../store';

export const SelectStatus = (state: RootState) => state.statuses;
